import { render, staticRenderFns } from "./HomeInternet.vue?vue&type=template&id=eb4af864&scoped=true&"
import script from "./HomeInternet.vue?vue&type=script&lang=js&"
export * from "./HomeInternet.vue?vue&type=script&lang=js&"
import style0 from "./HomeInternet.vue?vue&type=style&index=0&id=eb4af864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4af864",
  null
  
)

export default component.exports